import { module as modujs } from "modujs";

import { gsap } from "gsap";

import Swup from "swup";
import SwupGtmPlugin from "@swup/gtm-plugin";
import SwupHeadPlugin from "@swup/head-plugin";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupA11yPlugin from "@swup/a11y-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.defaultLanguage = "fr";
		this.additionalLanguages = ["en"];
	}

	init() {
		this.swup = new Swup({
			animateHistoryBrowsing: true,
			ignoreVisit: (url, { el } = {}) => {
				const current = document.documentElement.lang?.slice(0, 2) || this.defaultLanguage;
				const target = this.getLanguageCodeFromUrl(url) || this.defaultLanguage;
				return target !== current || el?.closest("[data-swup-prevent]");
			},
			plugins: [
				new SwupGtmPlugin(),
				new SwupHeadPlugin({
					persistAssets: true,
				}),
				new SwupPreloadPlugin(),
				new SwupA11yPlugin(),
				new SwupBodyClassPlugin(),
			],
		});

		window.swup = this.swup;

		this.swup.hooks.replace("animation:out:await", async (event) => {
			await gsap.to("#swup", { opacity: 0, duration: 0.3, ease: "power1.out" });
		});

		this.swup.hooks.replace("animation:in:await", async (event) => {
			await gsap.fromTo("#swup", { opacity: 0 }, { opacity: 1, duration: 0.3, ease: "power1.out" });
		});

		this.swup.hooks.on("content:replace", () => {
			if (typeof wpcf7 !== "undefined" && typeof wpcf7.init === "function") {
				document.querySelectorAll(".wpcf7 > form").forEach(function (form) {
					wpcf7.init(form);
				});
			}

			document.querySelectorAll("video[autoplay]").forEach((video) => {
				video.muted = true;
				video.play();
			});

			const main = document.querySelector("main");
			let translations = main?.getAttribute("data-translations");

			if (translations) {
				try {
					translations = JSON.parse(translations);

					if (Array.isArray(translations)) {
						translations.forEach((translation) => {
							if (translation?.locale && translation?.url) {
								document.querySelectorAll(`[data-translation-url="${translation.locale}"]`).forEach((element) => {
									element.href = translation.url;
								});
							}
						});
					}
				} catch (err) {
					console.error("Invalid JSON in data-translations:", err);
				}
			}
		});

		this.swup.hooks.on("page:load", (visit) => {
			visit.containers.forEach((container) => {
				container = document.querySelector(container);
				this.call("destroy", container, "app");
			});
		});

		this.swup.hooks.on("page:view", (visit) => {
			visit.containers.forEach((container) => {
				container = document.querySelector(container);
				this.call("update", container, "app");
			});
		});
	}

	getLanguageCodeFromUrl(url) {
		const u = new URL(url, location.origin);
		const seg = u.pathname.split("/").filter(Boolean)[0]; // first path segment
		return seg && this.additionalLanguages.includes(seg) ? seg : null;
	}

	destroy() {
		this.swup.destroy();
		window.swup = undefined;
	}
}
